import { RouterProvider } from 'react-router-dom';
import { OfflineBanner } from '@clarix/ui-shared';
import { ToastProvider } from '@clarix/ui';
import { AuthProvider } from '@clarix/contexts';
import { router } from '@/routes/router';
import { AppStatusGate } from '@/gateway/AppStatusGate';

export default function App() {
  return (
    <AppStatusGate>
      {/* Shell-owned screens (ShellHome at /home) render OUTSIDE every remote, so
          they get no provider from one — and useAuth throws without it. Derives
          purely from the JWT in @clarix/auth-store (an MF singleton), so the
          shell and the remotes always read the identical user. */}
      <AuthProvider>
        {/* The shell's OWN react-hot-toast <Toaster>. @clarix/ui is NOT an MF
            singleton (see tools/mf/shared.ts), so the shell has its own toast
            store, separate from every remote's — without this, toasts fired by
            shell-owned UI (e.g. deleting a CRM object from the sidebar) land in a
            store with no renderer and never show. Separate stores also mean this
            Toaster only ever renders shell toasts, so it can't double-render a
            remote's (e.g. CRM's) own toasts. */}
        <ToastProvider>
          {/* Thin top strip when the browser is offline — the lightweight signal for a
              connectivity problem, distinct from the full per-app maintenance swap
              (reserved for a genuine backend outage). */}
          <OfflineBanner />
          <RouterProvider router={router} />
        </ToastProvider>
      </AuthProvider>
    </AppStatusGate>
  );
}
